import Vue from 'vue'
import Offline from './Offline'
import ConfirmPayment from './ConfirmPayment'
[Offline, ConfirmPayment].forEach(item => {
    Vue.component(item.name, item)
})
